import api from './api';

const advertisementService = {
  // Obtenir toutes les publicités (admin)
  getAdvertisements: async (params = {}) => {
    const queryParams = new URLSearchParams();
    
    if (params.page) queryParams.append('page', params.page);
    if (params.limit) queryParams.append('limit', params.limit);
    if (params.isActive !== undefined) queryParams.append('isActive', params.isActive);
    if (params.search) queryParams.append('search', params.search);

    const response = await api.get(`/advertisements?${queryParams.toString()}`);
    return response.data;
  },

  // Obtenir les publicités actives (frontend)
  getActiveAdvertisements: async () => {
    const response = await api.get('/advertisements/active');
    return response.data;
  },

  // Obtenir une publicité par ID
  getAdvertisementById: async (id) => {
    const response = await api.get(`/advertisements/${id}`);
    return response.data;
  },

  // Créer une nouvelle publicité
  createAdvertisement: async (advertisementData) => {
    const response = await api.post('/advertisements', advertisementData);
    return response.data;
  },

  // Mettre à jour une publicité
  updateAdvertisement: async (id, advertisementData) => {
    const response = await api.put(`/advertisements/${id}`, advertisementData);
    return response.data;
  },

  // Supprimer une publicité
  deleteAdvertisement: async (id) => {
    const response = await api.delete(`/advertisements/${id}`);
    return response.data;
  },

  // Basculer le statut d'une publicité
  toggleAdvertisementStatus: async (id) => {
    const response = await api.patch(`/advertisements/${id}/toggle`);
    return response.data;
  },

  // Réorganiser les publicités
  reorderAdvertisements: async (advertisements) => {
    const response = await api.patch('/advertisements/reorder', { advertisements });
    return response.data;
  }
};

export default advertisementService;
